const GA_TRACKING_ID = 'UA-77515350-4';
const GA_APP_NAME = 'Planner';

import angular from 'angular';
import aria from 'angular-aria';
import core from './core/core.module';
import components from './components';
import services from './services';

const app = angular.module('app', [
    aria,
    core,
    components,
    services
]);

app.config(['$compileProvider', $compileProvider => $compileProvider.debugInfoEnabled(false)]);

app.config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
  }]);
/*
//Configure Google Analytics 
*/
app.run(['$rootScope', '$location', '$window', function ($rootScope, $location, $window) {
    if ($window.ga) {
        $window.ga('create', GA_TRACKING_ID, {cookieFlags:'samesite=Lax'});
        $window.ga('set', 'appName', GA_APP_NAME);
    }

    $rootScope.$on('$stateChangeSuccess', function (event) {
        if (!$window.ga) {
            return;
        }
        $window.ga('send', 'pageview', { page: $location.path(), hostname: $location.host(), location: $location.absUrl() });
    });
}]);

export default app;



// WEBPACK FOOTER //
// ./src/js/app.module.js